import {
	AccountLevelEnum,
	AccountStatusEnum,
	ButtonColorEnum,
	ButtonVariantEnum,
	CarrierAccountStatusEnum,
	CarrierPaymentTypeEnum,
	CarriersEnum,
	CarrierStatusEnum,
	GroundEconomyPickUpCarrierEnum,
	USPSPaymentAccountTypeEnum,
	SCACEnum,
	SnackBarVariants,
	RatingModeEnum,
	USPSAutoManifestScheduleSourceTypeEnum,
	UserRole,
	USPSRequestMappingModeEnum,
} from '@app/app.enum';
import { history } from '@app/app.routes';
import store from '@app/app.store';
import * as models from '@app/models';
import Injector from '@app/services';
import { AccountService } from '@app/services/account.service';
import { AdminCarrierAccountService } from '@app/services/admin-carrier-account.service';
import { CarrierAccountService } from '@app/services/carrier-account.service';
import { IntlService } from '@app/services/intl.service';
import { SharedService } from '@app/services/shared.service';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	Grid,
	GridList,
	GridListTile,
	IconButton,
	ListItem,
	ListItemAvatar,
	ListItemSecondaryAction,
	ListItemText,
	Menu,
	MenuItem,
	Step,
	StepLabel,
	Stepper,
	Typography,
} from '@material-ui/core';
import { StyleRules, withStyles } from '@material-ui/core/styles';
import Axios, { CancelTokenSource } from 'axios';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import withSnackBar from '../core/message.component';
import CustomButtonComponent from '../shared/custom-button.component';
import Icon from '../shared/icon.component';
import Ribbon from '../shared/ribbon.component';
import CustomDialogBox from './../shared/dialog.component';
import CarrierDetailsComponent from './carrier-details.component';
import CarriersListComponent from './carriers-list.component';
import FedexNativeComponent from './fedex-native.component';
import SCACListComponent from './scac-list.component';
import TierOverrideComponent from './tier-override.component';
import UPSNativeComponent from './ups-native.component';
import USPSConfigComponent from './usps-config.component';
import * as _ from 'lodash';
import { isNullOrUndefined } from 'util';
import USPSAutoManifestScheduleComponent from './usps-auto-manifest-schedule.component';
import PaymentModeConfigComponent from './payment-mode-config.component';

const intlService: IntlService = Injector.get(IntlService);
const accountService: AccountService = Injector.get(AccountService);
const sharedService: SharedService = Injector.get(SharedService);
const carrierAccountService: CarrierAccountService = Injector.get(CarrierAccountService);
const adminCarrierAccountService: AdminCarrierAccountService = Injector.get(AdminCarrierAccountService);

const styles: StyleRules = {
	card: {
		cursor: 'pointer',
	},
};

const initialCarrierDetailsValues: models.ICarrierDetails = {
	name: '',
	description: '',
	carrierDescription: '',
	appId: '',
	carrierCode: null,
};
interface IAccountStatausDialog {
	openDialog: boolean;
	accountStatus: CarrierAccountStatusEnum;
}

let carrierData: models.ICarrierAccounts;
let carrierConfig: models.ICarrierAccountConfiguration;
let tierOverrideConfig: models.ITierOverrideConfigs;

const initialSelectedCarrier: models.ICarrier = {
	id: null,
	code: null,
	scac: null,
	name: null,
	logo: null,
	description: null,
	provider: null,
	paymentType: null,
	status: null,
};

const newModalBaseSteps: string[] = [
	intlService.GetFormattedMessage('app.scac-select-label'),
	intlService.GetFormattedMessage('app.carrier-select-label'),
];

const editModalBaseSteps: string[] = [intlService.GetFormattedMessage('app.carrier-details-label')];

const configStepperButton = (
	buttonText: string,
	onClick: () => void,
	type: 'back' | 'next',
	disabled: boolean = false,
	showLoader: boolean = false
) => (
	<CustomButtonComponent
		color={type === 'back' ? ButtonColorEnum.Primary : ButtonColorEnum.Secondary}
		variant={type === 'back' ? ButtonVariantEnum.Outlined : ButtonVariantEnum.Contained}
		disabled={disabled || showLoader}
		onClick={onClick}
		buttonText={buttonText}
		loading={showLoader}
	/>
);

const CustomDialogButtonTextConfigs = {
	YesButtonText: intlService.GetFormattedMessage('app.common.dialog-okay-button-text'),
	passCustomText: false,
};

const CarrierCardComponent: React.FunctionComponent<models.ICarrierCardProps> = (props) => {
	// TODO: Source to cancel the axios requests
	const dialogCancellationSource = Axios.CancelToken.source();

	const [activeStep, setActiveStep] = useState<number>(0);
	const [steps, setSteps] = useState<string[]>(props.isNew ? newModalBaseSteps : editModalBaseSteps);

	const carrierDetailsRef = useRef(null);
	const carrierConfigRef = useRef(null);
	const tierOverrideConfigRef = useRef(null);

	const [showLoader, setShowLoader] = useState<boolean>(false);
	const [isAccountClosed, setIsAccountClosed] = useState<boolean>(false);
	const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
	const [isCarrierDeleteFailed, setIsCarrierDeleteFailed] = useState<boolean>(false);
	const [carrierDeleteDialogDescription, setCarrierDeleteDialogDescription] = useState<string | React.ReactNode>('');
	const [accountStatusDialog, setAccountStatusDialog] = useState<IAccountStatausDialog>({
		openDialog: false,
		accountStatus: CarrierAccountStatusEnum.Enabled,
	});
	const [configDialogContent, setConfigDialogContent] = useState<models.ICarrierAccountConfigDialog>({
		openConfig: false,
		paymentType: null,
	});
	const [openCarrierModal, setOpenCarrierModal] = useState<boolean>(false);
	const [carrierConfigDetails, setCarrierConfigDetails] = useState<any>(null);
	const [tierOverrideConfigDetails, setTierOverrideConfigDetails] = useState<models.ITierOverrideConfigs>(null);
	const [openEditCarrierModal, setEditCarrierModal] = useState<boolean>(() => {
		if (props.isRoutedFrom === 'ProfileCompleteness') {
			return true;
		}
		return false;
	});
	const [selectedCarrier, setSelectedCarrier] = useState<models.ICarrier>(initialSelectedCarrier);
	const [selectedSCAC, setSelectedSCAC] = useState<SCACEnum>(null);
	const [userCarrier, setUserCarrierDetails] = useState<models.ICarrierAccounts>(props.carrier);
	const [carrierDetails, setCarrierDetails] = useState<models.ICarrierDetails>(initialCarrierDetailsValues);
	const [isTrackingRangeImported, setIsTrackingRangeImported] = useState<boolean>(true);
	const account = useMemo(() => store.getState().authentication.user.account, []);
	const userData = useMemo<models.IUserSignInResponse>(accountService.getUserData, []);

	useEffect(() => {
		setIsAccountClosed(store.getState().authentication.status === AccountStatusEnum.Closed);
	}, []);

	useEffect(() => {
		// Set passCustomText to false during dialog closure
		// in order to stop passing custom dialog button text
		CustomDialogButtonTextConfigs.passCustomText = false;
	}, [openDeleteDialog]);

	useEffect(() => {
		setUserCarrierDetails(props.carrier);
		setConfigDialogContent({
			paymentType: props?.carrier?.paymentType,
			openConfig: false,
		});
	}, [props.carrier]);

	useEffect(() => {
		let mount = true;

		// Set UPS configs
		if (!!userCarrier && !!userCarrier.configuration.AccountNumber) {
			setCarrierConfigDetails({
				accountNumber: userCarrier.configuration.AccountNumber,
				bookNumber: userCarrier.configuration.BookNumber,
				pageNumber: userCarrier.configuration.PageNumber,
				sequenceNumberStart: userCarrier.configuration.SequenceNumberStart,
				sequenceNumberEnd: userCarrier.configuration.SequenceNumberEnd,
				carrierAccountId: userCarrier.id,
				sequenceNumber: userCarrier.configuration.SequenceNumberStart,
			});
		}

		// Set FedEx configs
		if (!!userCarrier && !!userCarrier.configuration.ShipperAccountNumber) {
			setCarrierConfigDetails({
				carrierAccountId: userCarrier.id,
				sequenceNumberStart: userCarrier.configuration.SequenceNumberStart,
				sequenceNumberEnd: userCarrier.configuration.SequenceNumberEnd,
				sequenceNumber: userCarrier.configuration.SequenceNumberStart,
				meterNumber: userCarrier.configuration.MeterNumber,
				billingAccountNumber: userCarrier.configuration.BillingAccountNumber,
				billingGroundAccountNumber: userCarrier.configuration.BillingGroundAccountNumber,
				shipperGroundAccountNumber: userCarrier.configuration.ShipperGroundAccountNumber,
				shipperAccountNumber: userCarrier.configuration.ShipperAccountNumber,
				smartPostId: userCarrier.configuration.SmartPostId,
				smartPostHubId: userCarrier.configuration.SmartPostHubId,
				smartPostMailerId: userCarrier.configuration.SmartPostMailerId,
				smartPostDistributionCenter: userCarrier.configuration.SmartPostDistributionCenter,
				ratingMode: userCarrier.configuration.RatingMode as RatingModeEnum,
				groundEconomyPickUpCarrier: userCarrier.configuration
					.GroundEconomyPickUpCarrier as GroundEconomyPickUpCarrierEnum,
				alternateId: userCarrier.alternateId,
			});
		}

		// Set USPS configs
		if (!!userCarrier && !!userCarrier.configuration.ShipFromAddressId) {
			// Get address -> set address and carrierAccountConfigs
			accountService.getAddress(userCarrier.configuration.ShipFromAddressId).then((res) => {
				if (mount) {
					setCarrierConfigDetails({
						city: res.city,
						company: res.company,
						country: res.country,
						state: res.state,
						street1: res.street1,
						street2: res.street2,
						street3: res.street3,
						zip: res.zip,
						phone: res.phone,
						email: res.email || '',
						name: res.name,
						ratingMode: userCarrier.configuration.RatingMode as RatingModeEnum,
						printAltReturnAddressOnUSPSLabel: userCarrier.configuration.PrintAltReturnAddressOnUSPSLabel,
						USPSPrintEntryFacilityNameOnLabel: userCarrier.configuration.USPSPrintEntryFacilityNameOnLabel,
						mraReturnsMid: userCarrier.configuration.MRAReturnsMid,
						mraAccountCode: userCarrier.configuration.MRAAccountCode,
						LabelOwner_CRID: userCarrier.configuration.LabelOwner_CRID,
						LabelOwner_MID: userCarrier.configuration.LabelOwner_MID,
						LabelOwner_ManifestMID: userCarrier.configuration.LabelOwner_ManifestMID,
						ReturnLabelOwner_CRID: userCarrier.configuration.ReturnLabelOwner_CRID,
						ReturnLabelOwner_MID: userCarrier.configuration.ReturnLabelOwner_MID,
						ReturnLabelOwner_ManifestMID: userCarrier.configuration.ReturnLabelOwner_ManifestMID,
						Shipper_CRID: userCarrier.configuration.Shipper_CRID,
						Shipper_MID: userCarrier.configuration.Shipper_MID,
						MailOwner_MID: userCarrier.configuration.MailOwner_MID,
						ConsumerKey: userCarrier.configuration.ConsumerKey,
						ConsumerSecret: userCarrier.configuration.ConsumerSecret,
						Payer_CRID: userCarrier.configuration.Payer_CRID,
						Payer_EPSAccountNumber: userCarrier.configuration.Payer_EPSAccountNumber,
						Payer_PermitNumber: userCarrier.configuration.Payer_PermitNumber,
						Payer_PermitZIP: userCarrier.configuration.Payer_PermitZIP,
						Payer_AccountType: userCarrier.configuration.Payer_AccountType as USPSPaymentAccountTypeEnum,
						alternateId: userCarrier.alternateId,
						USPSRequestMappingMode: userCarrier.configuration.USPSRequestMappingMode as USPSRequestMappingModeEnum,
					});
				}
			});

			if (shouldDisplayTierOverride(userCarrier.carrierCode)) {
				// Get tierOverrideConfigs and set them to state
				adminCarrierAccountService.GetTierOverrideCarrierAccountConfig(userCarrier.id).then((res) => {
					if (!_.isEmpty(res)) {
						setTierOverrideConfigDetails({
							USPSeVSWebtoolId: res.USPSeVSWebtoolId,
							USPSeVSWebtoolPassword: res.USPSeVSWebtoolPassword,
							USPSeVSWebtoolMID: res.USPSeVSWebtoolMID,
							MailOwner_MID: res.MailOwner_MID,
							USPSeVSMID: res.USPSeVSMID,
							ConsumerKey: res.ConsumerKey,
							ConsumerSecret: res.ConsumerSecret,
						});
					}
				});
			}
		}

		return () => {
			mount = false;
		};
	}, [userCarrier]);

	useEffect(() => {
		if (activeStep === 0) {
			setCarrierDetails(initialCarrierDetailsValues);
		}
	}, [activeStep]);

	useEffect(() => {
		if (!isNullOrUndefined(carrierData) && carrierData?.carrierCode === selectedCarrier.code) {
			setCarrierDetails({
				name: carrierData.name,
				description: carrierData.description,
				carrierDescription: selectedCarrier.description,
				appId: '',
				carrierCode: carrierData.carrierCode,
			});
		} else if (selectedCarrier.name && selectedCarrier.description) {
			setCarrierDetails({
				name: selectedCarrier.name,
				description: intlService.GetFormattedMessage('app.carrier-description-default-value', {
					0: selectedCarrier.name,
				}),
				carrierDescription: selectedCarrier.description,
				appId: '',
				carrierCode: selectedCarrier.code,
			});
		} else {
			setCarrierDetails(initialCarrierDetailsValues);
		}
	}, [selectedCarrier, carrierData]);

	useEffect(() => {
		const displayCarrierConfiguration = shouldDisplayCarrierConfiguration(selectedCarrier.code);
		const displayTierOverride = shouldDisplayTierOverride(selectedCarrier.code);

		const baseSteps = props.isNew ? [...newModalBaseSteps] : [...editModalBaseSteps];
		let stepsToSet = [...baseSteps];

		if (displayCarrierConfiguration || displayTierOverride) {
			// Add configuration step and set falg to not set default steps
			if (displayCarrierConfiguration) {
				stepsToSet = [
					...stepsToSet,
					props.intl.formatMessage({
						id: 'app.carrier-configuration-label',
					}),
				];
			}

			// Add configuration step and set falg to not set default steps
			if (displayTierOverride) {
				stepsToSet = [
					...stepsToSet,
					props.intl.formatMessage({
						id: 'app.carrier-tier-override-label',
					}),
				];
			}
		} else {
			// Set default steps if steps were not set previously
			stepsToSet = [...baseSteps];
		}

		setSteps(stepsToSet);
	}, [selectedCarrier]);

	/**
	 * Check whether selected carrier required configuration or not
	 */
	const shouldDisplayCarrierConfiguration = (carrierCode: CarriersEnum) => {
		return (
			carrierCode === CarriersEnum.USPSePostage ||
			carrierCode === CarriersEnum.USPSePostageNative ||
			carrierCode === CarriersEnum.USPSeVS ||
			carrierCode === CarriersEnum.USPSeVSNative ||
			carrierCode === CarriersEnum.USPSShip ||
			carrierCode === CarriersEnum.USPSePostageWarehouse ||
			carrierCode === CarriersEnum.USPSePostagePostPay ||
			carrierCode === CarriersEnum.UPSNative ||
			carrierCode === CarriersEnum.FedExNative
		);
	};

	const shouldDisplayTierOverride = (carrierCode: CarriersEnum) => {
		// Tier override works only for ePostage, eVS
		// UI is only visible to admin
		return (
			accountService.IsAdmin(userData.user.role) &&
			(carrierCode === CarriersEnum.USPSePostage ||
				carrierCode === CarriersEnum.USPSeVS ||
				carrierCode === CarriersEnum.USPSShip ||
				carrierCode === CarriersEnum.USPSeVSNative ||
				carrierCode === CarriersEnum.USPSePostageNative)
		);
	};

	const updateCarrierDetails = useCallback(async (): Promise<boolean> => {
		try {
			const carrierDetailsFormValues = await carrierDetailsRef.current.getWrappedInstance().getFormValues();

			if (!!carrierDetailsFormValues) {
				carrierData = { ...carrierDetailsFormValues };
				return true;
			}
			return false;
		} catch (err) {
			throw err;
		}
	}, []);

	const updateCarrierConfig = useCallback(async (): Promise<boolean> => {
		const carrierConfigFormValues = await carrierConfigRef.current.getWrappedInstance().getFormValues();

		if (!!carrierConfigFormValues) {
			carrierConfig = carrierConfigFormValues;
			return true;
		}
		return false;
	}, []);

	const updateTierOverrideConfig = useCallback(async (): Promise<boolean> => {
		const tierOverrideConfigFormValues = await tierOverrideConfigRef.current.getWrappedInstance().getFormValues();

		if (!!tierOverrideConfigFormValues) {
			tierOverrideConfig = tierOverrideConfigFormValues;
			return true;
		}
		return false;
	}, []);

	const saveCarrierDetails = useCallback(
		async (
			carrierCode: CarriersEnum,
			carrierDescription: string,
			carrierDetailsData: models.ICarrierAccounts,
			carrierConfigData: any,
			tierOverrideConfigData: models.ITierOverrideConfigs
		) => {
			try {
				// Pass accountId only when admin is trying to add a Carrier
				const accountId = accountService.IsAdmin(userData.user.role) ? history.location.state.app.accountId : null;
				setShowLoader(true);
				const result = await insertCarrierConfiguration(carrierConfigData, carrierCode, accountId);
				carrierDetailsData.configuration = { ...result };
				carrierDetailsData.carrierCode = carrierCode;
				carrierDetailsData.carrierDescription = carrierDescription;
				carrierDetailsData.accountId = accountId;
				carrierDetailsData.alternateId = carrierConfigData?.alternateId;

				let res;
				if (!props.isNew) {
					carrierDetailsData.id = userCarrier.id;
					res = await carrierAccountService.EditCarrierAccount(
						carrierDetailsData,
						carrierDetailsData.appId,
						dialogCancellationSource.token
					);
					setUserCarrierDetails({ ...res });
					props.openSnackBar(
						props.intl.formatMessage({
							id: 'app.snackbar.carrier-updated-successfully',
						})
					);
				} else {
					res = await carrierAccountService.CreateCarrierAccount(
						carrierDetailsData,
						carrierDetailsData.appId,
						dialogCancellationSource.token
					);

					if (res.status === CarrierAccountStatusEnum.Requested) {
						props.openSnackBar(
							props.intl.formatMessage({
								id: 'app.snackbar.requested-carrier-added-successfully',
							})
						);
					} else {
						props.openSnackBar(
							props.intl.formatMessage({
								id: 'app.snackbar.carrier-added-successfully',
							})
						);
					}
				}
				props.onUpdatingCarrier(res);
				await actionAfterCreateOrUpdateCarrierAccount(carrierCode, res.id, carrierConfigData, tierOverrideConfigData);
				resetCommonStates();
				setIsTrackingRangeImported(true);
			} catch (err) {
				setShowLoader(false);
				props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
			}
		},
		[userCarrier]
	);

	const resetCommonStates = useCallback(() => {
		setActiveStep(0);
		setShowLoader(false);
		setOpenCarrierModal(false);
		setEditCarrierModal(false);
		setIsTrackingRangeImported(true);
		setCarrierDetails(initialCarrierDetailsValues);

		// Reset globals
		carrierData = null;
		carrierConfig = null;
		tierOverrideConfig = null;
	}, []);

	const updateSelectedCarrier = useCallback((carrier: models.ICarrier) => {
		setSelectedCarrier(carrier);
	}, []);

	const updateSelectedSCAC = useCallback((scac: SCACEnum) => {
		setSelectedSCAC(scac);
	}, []);

	const insertCarrierConfiguration = useCallback(
		async (
			eventData: any,
			carrierType: CarriersEnum,
			accountId: string
		): Promise<models.ICarrierAccountConfigurations> => {
			try {
				let result: models.ICarrierAccountConfigurations = null;
				switch (carrierType) {
					case CarriersEnum.USPSeVS:
					case CarriersEnum.USPSeVSNative:
					case CarriersEnum.USPSePostage:
					case CarriersEnum.USPSePostageNative:
					case CarriersEnum.USPSShip:
					case CarriersEnum.USPSePostageWarehouse:
					case CarriersEnum.USPSePostagePostPay:
						const configAddress: models.ISenderInfoFields = {
							company: eventData.company,
							street1: eventData.street1,
							street2: eventData.street2,
							street3: eventData.street3,
							city: eventData.city,
							state: eventData.state,
							zip: eventData.zip,
							country: eventData.country,
							phone: eventData.phone,
							email: eventData.email,
							name: eventData.name,
						};

						const savedAddress = await createCarrierConfigAddress(configAddress, carrierType, accountId);

						result = {
							...savedAddress,
							PrintAltReturnAddressOnUSPSLabel: eventData.printAltReturnAddressOnUSPSLabel,
							USPSPrintEntryFacilityNameOnLabel: eventData.USPSPrintEntryFacilityNameOnLabel,
							MRAReturnsMid: eventData.mraReturnsMid,
							MRAAccountCode: eventData.mraAccountCode,
							RatingMode: eventData.ratingMode,
							USPSRequestMappingMode: eventData.USPSRequestMappingMode,
						};

						// Add ship-api OR admin only configs if it admin
						if (accountService.IsAdmin(userData.user.role)) {
							result = {
								...result,
								LabelOwner_MID: eventData.LabelOwner_MID,
								LabelOwner_CRID: eventData.LabelOwner_CRID,
								LabelOwner_ManifestMID: eventData.LabelOwner_ManifestMID,
								MailOwner_MID: eventData.MailOwner_MID,
								Payer_CRID: eventData.Payer_CRID,
								ReturnLabelOwner_CRID: eventData.ReturnLabelOwner_CRID,
								ReturnLabelOwner_MID: eventData.ReturnLabelOwner_MID,
								ReturnLabelOwner_ManifestMID: eventData.ReturnLabelOwner_ManifestMID,
								Shipper_CRID: eventData.Shipper_CRID,
								ConsumerKey: eventData.ConsumerKey,
								ConsumerSecret: eventData.ConsumerSecret,
								Payer_EPSAccountNumber: eventData.Payer_EPSAccountNumber,
								Payer_PermitNumber: eventData.Payer_PermitNumber,
								Payer_PermitZIP: eventData.Payer_PermitZIP,
								Payer_AccountType: eventData.Payer_AccountType,
								Shipper_MID: eventData.Shipper_MID,
							};
						}

						break;
					case CarriersEnum.UPSNative:
						result = {
							AccountNumber: eventData.accountNumber,
							BookNumber: eventData.bookNumber,
							PageNumber: eventData.pageNumber,
							SequenceNumberStart: eventData.sequenceNumberStart,
							SequenceNumberEnd: eventData.sequenceNumberEnd,
						};
						break;
					case CarriersEnum.FedExNative:
						result = {
							MeterNumber: eventData.meterNumber,
							BillingAccountNumber: eventData.billingAccountNumber,
							BillingGroundAccountNumber: eventData.billingGroundAccountNumber,
							ShipperAccountNumber: eventData.shipperAccountNumber,
							ShipperGroundAccountNumber: eventData.shipperGroundAccountNumber,
							SmartPostId: eventData.isSmartPostEnabled ? eventData.smartPostId : null,
							SmartPostHubId: eventData.isSmartPostEnabled ? eventData.smartPostHubId : null,
							SmartPostMailerId: eventData.isSmartPostEnabled ? eventData.smartPostMailerId : null,
							SmartPostDistributionCenter: eventData.isSmartPostEnabled ? eventData.smartPostDistributionCenter : null,
							GroundEconomyPickUpCarrier: eventData.isSmartPostEnabled ? eventData.groundEconomyPickUpCarrier : null,
							RatingMode: eventData.ratingMode,
						};
						break;
					case CarriersEnum.USPSeVSWarehouse:
					case CarriersEnum.USPSPHv2:
					case CarriersEnum.UPSPHv2:
					case CarriersEnum.DHLExpressPHv2:
					case CarriersEnum.PBPHv2:
					default:
						return null;
				}
				return result;
			} catch (err) {
				throw err;
			}
		},
		[]
	);

	const getCarrierConfigurationComponent = useCallback(
		(carrierCode: CarriersEnum, name: string, logo: string, paymentType: CarrierPaymentTypeEnum) => {
			switch (carrierCode) {
				case CarriersEnum.USPSeVS:
				case CarriersEnum.USPSeVSNative:
				case CarriersEnum.USPSePostage:
				case CarriersEnum.USPSePostageNative:
				case CarriersEnum.USPSShip:
				case CarriersEnum.USPSePostageWarehouse:
				case CarriersEnum.USPSePostagePostPay:
					return (
						<USPSConfigComponent
							ref={carrierConfigRef}
							selectedCarrierName={name}
							selectedCarrierLogo={logo}
							carrierCode={carrierCode}
							preloadedData={{ ...carrierConfigDetails, ...carrierConfig }}
							paymentType={paymentType}
						/>
					);
				case CarriersEnum.UPSNative:
					return (
						<UPSNativeComponent
							ref={carrierConfigRef}
							selectedCarrierName={name}
							selectedCarrierLogo={logo}
							preloadedData={{ ...carrierConfigDetails, ...carrierConfig }}
						/>
					);
				case CarriersEnum.FedExNative:
					return (
						<FedexNativeComponent
							ref={carrierConfigRef}
							selectedCarrierName={name}
							selectedCarrierLogo={logo}
							preloadedData={{ ...carrierConfigDetails, ...carrierConfig }}
							setIsTrackingRangeImported={setIsTrackingRangeImported}
							isTrackingRangeImported={isTrackingRangeImported}
							paymentType={paymentType}
						/>
					);
				case CarriersEnum.USPSPHv2:
				case CarriersEnum.UPSPHv2:
				case CarriersEnum.DHLExpressPHv2:
				case CarriersEnum.USPSeVSWarehouse:
				case CarriersEnum.PBPHv2:
				default:
					return null;
			}
		},
		[selectedCarrier, carrierConfigDetails, isTrackingRangeImported]
	);

	const createCarrierConfigAddress = useCallback(
		async (
			eventData: models.ISenderInfoFields,
			carriersType: CarriersEnum,
			accountId: string
		): Promise<models.ICarrierAccountConfigurations> => {
			try {
				eventData.verify = true;
				eventData.save = true;
				const result = await accountService.createCarrierConfigAddress(
					eventData,
					carriersType,
					accountId,
					dialogCancellationSource.token
				);
				return {
					ShipFromAddressId: result.id,
				};
			} catch (error) {
				throw error;
			}
		},
		[]
	);

	const manageCarrierDialog = useCallback(
		(open: boolean, popupState?: models.IMenuInjectedProps, cancellationSource?: CancelTokenSource) => {
			if (popupState) {
				popupState.close();
			}

			if (!open && !!cancellationSource) {
				cancellationSource.cancel();
				return;
			}

			setActiveStep(0);
			setOpenCarrierModal(open);
			updateSelectedCarrier(initialSelectedCarrier);
			updateSelectedSCAC(null);
			carrierConfig = null;
			tierOverrideConfig = null;
			carrierData = null;
		},
		[]
	);

	const deleteCarrier = useCallback(
		async (appId: string, carrierId: string) => {
			try {
				setShowLoader(true);
				if (!accountService.IsAdmin(userData.user.role)) {
					await carrierAccountService.DeleteCarrierAccount(appId, carrierId);
				} else {
					await adminCarrierAccountService.DeleteCarrierAccountByAdmin(appId, carrierId);
				}
				setOpenDeleteDialog(false);
				setShowLoader(false);
				props.onDeletion(userCarrier.id);
			} catch (err) {
				setShowLoader(false);

				// Configure dialog description data for delete dialog
				setIsCarrierDeleteFailed(true);

				if (!Axios.isCancel(err)) {
					const errors = sharedService.parseError(err.data);
					const DeletionFailureErrorCode = 'CarrierAccount.Validation_Failed';

					if (sharedService.parseErrorCode(err.data).includes(DeletionFailureErrorCode.toUpperCase())) {
						const dialogDescriptionNode = (
							<>
								<Typography variant='body1'>{errors[0]}.</Typography>
								<Typography variant='body1'>
									{intlService.GetFormattedMessage('app.generic.deletion-failure-dialog-description')}
								</Typography>
							</>
						);

						// Set passCustomText to true
						// so that custom dialog button text get passed to the customDialog
						CustomDialogButtonTextConfigs.passCustomText = true;
						setCarrierDeleteDialogDescription(dialogDescriptionNode);

						return;
					}

					props.openSnackBar(errors, SnackBarVariants.Error);
				}
			}
		},
		[userCarrier]
	);

	const updateCarrierStatus = useCallback(
		async (accountStatus: CarrierAccountStatusEnum) => {
			try {
				setShowLoader(true);
				// Pass accountId only when admin is trying to add a Carrier
				const accountId = accountService.IsAdmin(userData.user.role) ? history.location.state.app.accountId : null;

				const carrierAccount: models.ICarrierAccounts = {
					...userCarrier,
					accountId,
					status: accountStatus,
					carrierDescription: selectedCarrier.description || '',
				};

				await carrierAccountService.EditCarrierAccount(
					carrierAccount,
					props.carrier.appId,
					dialogCancellationSource.token
				);

				setIsCarrierDeleteFailed(false);
				props.openSnackBar(
					intlService.GetFormattedMessage(`app.snackbar.carrier-account-${accountStatus.toLowerCase()}-successfully`)
				);
				setUserCarrierDetails(carrierAccount);
				props.onUpdatingCarrier(carrierAccount);
				resetCommonStates();
			} catch (err) {
				if (!Axios.isCancel(err)) {
					props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
				}
			}
		},
		[userCarrier]
	);

	const actionAfterCreateOrUpdateCarrierAccount = async (
		code: CarriersEnum,
		carrierAccountId: string,
		carrierAccountConfig?: any,
		tierOverrideConfigData?: models.ITierOverrideConfigs
	) => {
		switch (code) {
			case CarriersEnum.UPSNative:
				const sequenceNumberVM: models.ISequenceNumberVM = {
					carrierAccountId,
					sequenceNumber: carrierAccountConfig?.sequenceNumber,
				};
				try {
					return await accountService.UpdateSequenceNumber(sequenceNumberVM);
				} catch (err) {
					props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
				}

				break;
			case CarriersEnum.FedExNative:
				const updateRequest: models.IFedExNativeUpsertSequenceNumber = {
					accountNumber: carrierAccountConfig?.billingAccountNumber,
					meterNumber: carrierAccountConfig?.meterNumber,
					sequenceNumber: carrierAccountConfig?.sequenceNumber,
					sequenceNumberStart: carrierAccountConfig?.sequenceNumberStart,
					sequenceNumberEnd: carrierAccountConfig?.sequenceNumberEnd,
					smartPostMailerId: carrierAccountConfig?.smartPostMailerId,
				};
				try {
					return await accountService.UpdateFedExSequenceNumber(updateRequest);
				} catch (err) {
					props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
				}

				break;
			case CarriersEnum.USPSeVS:
			case CarriersEnum.USPSShip:
			case CarriersEnum.USPSeVSNative:
			case CarriersEnum.USPSePostage:
			case CarriersEnum.USPSePostageNative:
				if (tierOverrideConfigData !== null) {
					try {
						return await adminCarrierAccountService.UpsertTierOverrideCarrierAccountConfig(
							carrierAccountId,
							tierOverrideConfigData
						);
					} catch (err) {
						props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
					}
				}

				break;
			case CarriersEnum.USPSPHv2:
			case CarriersEnum.UPSPHv2:
			case CarriersEnum.DHLExpressPHv2:
			case CarriersEnum.USPSeVSWarehouse:
			case CarriersEnum.PBPHv2:
			case CarriersEnum.USPSePostageWarehouse:
			case CarriersEnum.USPSePostagePostPay:
			default:
		}
		carrierData = undefined;
		return null;
	};

	const renderMenu = useCallback(() => {
		return (
			!(account.level === AccountLevelEnum.Partner) &&
			userCarrier.status !== CarrierAccountStatusEnum.NotEligible && (
				<Grid container={true}>
					<Grid item={true}>
						<PopupState variant='popper'>
							{(popupState: models.IMenuInjectedProps) => (
								<React.Fragment>
									<IconButton {...bindTrigger(popupState)} color='inherit'>
										<Icon name='ellipsis-vertical' className='icon-dimension-square' />
									</IconButton>
									<Menu {...bindMenu(popupState)}>
										{userCarrier.status !== CarrierAccountStatusEnum.Disabled && (
											<MenuItem
												onClick={() => {
													setEditCarrierModal(true);
													popupState.close();
												}}
											>
												{intlService.GetFormattedMessage('app.app-view.app-card.edit')}
											</MenuItem>
										)}
										{(userCarrier.status === CarrierAccountStatusEnum.Disabled ||
											(accountService.IsAdmin(userData?.user?.role) &&
												userCarrier.status === CarrierAccountStatusEnum.Requested)) && (
											<MenuItem
												onClick={() => {
													setAccountStatusDialog({ openDialog: true, accountStatus: CarrierAccountStatusEnum.Enabled });
													popupState.close();
												}}
											>
												{intlService.GetFormattedMessage('app.user.enable')}
											</MenuItem>
										)}
										{(userCarrier.status === CarrierAccountStatusEnum.Enabled ||
											userCarrier.status === CarrierAccountStatusEnum.EnabledWithoutWatermark ||
											(accountService.IsAdmin(userData?.user?.role) &&
												userCarrier.status === CarrierAccountStatusEnum.Requested)) && (
											<MenuItem
												onClick={() => {
													setAccountStatusDialog({
														openDialog: true,
														accountStatus: CarrierAccountStatusEnum.Disabled,
													});
													popupState.close();
												}}
											>
												{intlService.GetFormattedMessage('app.user.disable')}
											</MenuItem>
										)}
										{userCarrier.status !== CarrierAccountStatusEnum.Disabled && (
											<MenuItem
												onClick={() => {
													const dialogDescriptionArg1 = intlService.GetFormattedMessage('app.user.delete');
													const dialogDescriptionArg2 = userCarrier.name;

													setOpenDeleteDialog(true);
													setCarrierDeleteDialogDescription(
														intlService.GetFormattedMessage('app.generic.delete-action-dialog-description', {
															[0]: dialogDescriptionArg1.toLowerCase(),
															[1]: dialogDescriptionArg2,
														})
													);
													popupState.close();
												}}
											>
												{intlService.GetFormattedMessage('app.user.delete')}
											</MenuItem>
										)}
										{userData.user &&
											(accountService.IsAdmin(userData.user.role) ||
												(userData.user.role === UserRole.AccountAdmin &&
													(userCarrier.carrierCode === CarriersEnum.USPSeVSNative ||
														userCarrier.carrierCode === CarriersEnum.USPSePostageNative))) &&
											userCarrier.status !== CarrierAccountStatusEnum.Disabled && (
												<MenuItem
													onClick={() => {
														setConfigDialogContent((prevState: models.ICarrierAccountConfigDialog) => ({
															...prevState,
															openConfig: true,
														}));
														popupState.close();
													}}
												>
													{intlService.GetFormattedMessage('app.billing.payment-button-configure-tag')}
												</MenuItem>
											)}
									</Menu>
								</React.Fragment>
							)}
						</PopupState>
					</Grid>
				</Grid>
			)
		);
	}, [selectedCarrier, userCarrier]);

	const renderNewCarrierDialog = useCallback(() => {
		const { code: carrierCode, name, logo, paymentType } = selectedCarrier;

		return (
			<Dialog
				open={openCarrierModal}
				fullWidth={true}
				maxWidth='md'
				onClose={() => {
					manageCarrierDialog(false, null, null);
				}}
				classes={{ paper: 'dialog-min-height' }}
			>
				<DialogTitle>
					<Grid container={true} spacing={2}>
						<Grid item={true} xs={12}>
							{props.intl.formatMessage({
								id: 'app.carrier.add-carrier-account-label',
							})}
						</Grid>
						<Grid item={true} xs={12}>
							{steps.length > 1 && (
								<Stepper activeStep={activeStep} classes={{ root: 'carrier-dialog-stepper' }}>
									{steps.map((label, index) => (
										<Step key={index}>
											<StepLabel>{label}</StepLabel>
										</Step>
									))}
								</Stepper>
							)}
						</Grid>
					</Grid>
				</DialogTitle>
				<DialogContent classes={{ root: 'hide-overflow-x dialog-content' }}>
					<div className='carriers-card padding-15'>
						{
							// IIFE is used here to handle stepper switch case
							(() => {
								let component = null;
								switch (activeStep) {
									case 0:
										component = <SCACListComponent onClick={updateSelectedSCAC} />;
										break;
									case 1:
										component = (
											<>
												<CarriersListComponent
													new={true}
													onClick={updateSelectedCarrier}
													applicableCarriers={props.applicableCarriers}
													userType={userData.user.role}
													appliedSCAC={selectedSCAC}
													selectedCarrierCode={carrierCode}
												/>
												<CarrierDetailsComponent
													ref={carrierDetailsRef}
													initialValues={{
														...carrierDetails,
														appId: props.appId,
													}}
												/>
											</>
										);
										break;
									case 2:
										component = getCarrierConfigurationComponent(carrierCode, name, logo, paymentType);
										break;

									case 3:
										component = (
											<TierOverrideComponent
												ref={tierOverrideConfigRef}
												preloadedData={{ ...tierOverrideConfigDetails, ...tierOverrideConfig }}
												selectedCarrierName={name}
												selectedCarrierLogo={logo}
												carrierCode={carrierCode}
											/>
										);
										break;
								}
								return component;
							})()
						}
					</div>
				</DialogContent>
				<DialogActions>{manageNewDialogButtons()}</DialogActions>
			</Dialog>
		);
	}, [activeStep, showLoader, openCarrierModal, selectedSCAC, selectedCarrier, carrierDetails, steps]);

	const renderEditCarrierDialog = useCallback(
		(carrierAccount: models.ICarrierAccounts) => {
			const { carrierCode, name, logo, scac, paymentType, carrierPaymentType } = carrierAccount;

			return (
				<Dialog
					open={openEditCarrierModal}
					fullWidth={true}
					maxWidth='md'
					classes={{ paper: 'dialog-min-height' }}
					onClose={() => {
						setActiveStep(0);
						setEditCarrierModal(false);
						setIsTrackingRangeImported(true);
						carrierConfig = null;
						tierOverrideConfig = null;
						carrierData = null;
					}}
				>
					<DialogTitle classes={{ root: 'carrier-dialog-title' }}>
						<Grid container={true} spacing={2}>
							<Grid item={true} xs={12}>
								{props.intl.formatMessage({
									id: 'app.carrier.edit-carrier-account-label',
								})}
							</Grid>
							<Grid item={true} xs={12}>
								{steps.length > 1 && (
									<Stepper activeStep={activeStep} classes={{ root: 'carrier-dialog-stepper' }}>
										{steps.map((label, index) => (
											<Step key={index}>
												<StepLabel>{label}</StepLabel>
											</Step>
										))}
									</Stepper>
								)}
							</Grid>
						</Grid>
					</DialogTitle>
					<DialogContent classes={{ root: 'hide-overflow-x dialog-content' }}>
						<div className='carriers-card padding-15'>
							{
								// IIFE is used here to handle stepper switch case
								(() => {
									let component = null;
									switch (activeStep) {
										case 0:
											component = (
												<>
													<CarriersListComponent
														new={false}
														onClick={updateSelectedCarrier}
														selectedCarrierCode={carrierCode}
														userType={userData.user.role}
														appliedSCAC={scac}
													/>
													<CarrierDetailsComponent
														ref={carrierDetailsRef}
														initialValues={{
															...(carrierData !== null && carrierData !== undefined
																? {
																		...userCarrier,
																		name: carrierData.name,
																		description: carrierData.description,
																  }
																: { ...userCarrier }),
															carrierDescription: selectedCarrier.description || '',
														}}
													/>
												</>
											);
											break;

										case 1:
											component = getCarrierConfigurationComponent(
												carrierCode,
												name,
												logo,
												paymentType ?? carrierPaymentType
											);
											break;

										case 2:
											component = (
												<TierOverrideComponent
													ref={tierOverrideConfigRef}
													preloadedData={{ ...tierOverrideConfigDetails, ...tierOverrideConfig }}
													selectedCarrierName={carrierAccount.name}
													selectedCarrierLogo={carrierAccount.logo}
													carrierCode={carrierCode}
												/>
											);
											break;
									}
									return component;
								})()
							}
						</div>
					</DialogContent>
					<DialogActions>{manageEditDialogButtons()}</DialogActions>
				</Dialog>
			);
		},
		[showLoader, activeStep, selectedCarrier, openEditCarrierModal, isTrackingRangeImported, steps]
	);

	/*
	 * This function returns the action buttons for each step based on the number of steps in the new form.
	 * e.g. For a 3-step form the first step will have a cancel and a next button,
	 * the second step will have a back and a next button
	 * and the third step will have a back and a save button
	 */
	const manageNewDialogButtons = useCallback(() => {
		const buttons = [];

		// Callbacks for first step (Which is always a cancel and a next button so it's not set in the following if blocks)
		const FirstStepOnBackHandler = () => manageCarrierDialog(false, null, null);
		const FirstStepOnNextHandler = () => setActiveStep(activeStep + 1);

		const FirstButton = (
			<>
				{/* Cancel Button */}
				{configStepperButton(
					props.intl.formatMessage({
						id: 'app.app-view.cancel-button',
					}),
					FirstStepOnBackHandler,
					'back'
				)}
				{/* Next Button */}
				{configStepperButton(
					props.intl.formatMessage({
						id: 'app.app-view.next-button',
					}),
					FirstStepOnNextHandler,
					'next',
					!selectedSCAC
				)}
			</>
		);

		switch (steps.length) {
			case 2:
				{
					/* For a 2-step form:
						- first step will have a cancel and a next button
						- the second step will have a back and a save button
					*/

					// Callbacks for second step
					const SecondStepOnBackHandler = () => {
						setActiveStep(activeStep - 1);
						setSelectedSCAC(null);
						setSelectedCarrier(initialSelectedCarrier);
					};

					const SecondStepOnSaveHandler = async () => {
						try {
							const updated = await updateCarrierDetails();
							if (updated) {
								saveCarrierDetails(selectedCarrier.code, selectedCarrier.description, carrierData, null, null);
							}
						} catch (err) {
							throw err;
						}
					};

					const SecondButton = (
						<>
							{/* Back Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.back-button',
								}),
								SecondStepOnBackHandler,
								'back'
							)}
							{/* Save Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.save-button',
								}),
								SecondStepOnSaveHandler,
								'next',
								!selectedCarrier.code,
								showLoader
							)}
						</>
					);

					buttons.push(FirstButton, SecondButton);
				}

				break;
			case 3:
				{
					/* For a 3-step form:
						- first step will have a cancel and a next button
						- the second step will have a back and a next button
						- the third step will have a back and a save button
					*/

					// Callbacks for Second step
					const SecondStepOnBackHandler = () => {
						setActiveStep(activeStep - 1);
						setSelectedSCAC(null);
						setSelectedCarrier(initialSelectedCarrier);
						carrierData = null;
					};

					const SecondButtonOnNextHandler = async () => {
						try {
							const updated = await updateCarrierDetails();
							if (updated) {
								setActiveStep(activeStep + 1);
							}
						} catch (err) {
							throw err;
						}
					};

					const SecondButton = (
						<>
							{/* Back Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.back-button',
								}),
								SecondStepOnBackHandler,
								'back'
							)}
							{/* Next Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.next-button',
								}),
								SecondButtonOnNextHandler,
								'next',
								!selectedCarrier.code
							)}
						</>
					);

					// Callbacks for Third step
					const ThirdStepOnBackHandler = () => {
						setActiveStep(activeStep - 1);
						updateSelectedCarrier(initialSelectedCarrier);
						carrierConfig = null;
					};
					const ThirdButtonOnSaveHandler = async () => {
						try {
							const updated = await updateCarrierConfig();
							if (updated) {
								saveCarrierDetails(selectedCarrier.code, selectedCarrier.description, carrierData, carrierConfig, null);
							}
						} catch (error) {
							throw error;
						}
					};

					const ThirdButton = (
						<>
							{/* Back Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.back-button',
								}),
								ThirdStepOnBackHandler,
								'back'
							)}
							{/* Save Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.save-button',
								}),
								ThirdButtonOnSaveHandler,
								'next',
								showLoader,
								showLoader
							)}
						</>
					);

					buttons.push(FirstButton, SecondButton, ThirdButton);
				}

				break;
			case 4:
				{
					/* For a 4-step form:
						- first step will have a cancel and a next button
						- the second step will have a back and a next button
						- the third step will also have a back and a next button
						- the fourth step will back and a next button
					*/

					// Callbacks for Second step
					const SecondStepOnBackHandler = () => {
						setActiveStep(activeStep - 1);
						setSelectedSCAC(null);
						setSelectedCarrier(initialSelectedCarrier);
						carrierData = null;
					};

					const SecondButtonOnNextHandler = async () => {
						try {
							const updated = await updateCarrierDetails();
							if (updated) {
								setActiveStep(activeStep + 1);
							}
						} catch (err) {
							throw err;
						}
					};

					const SecondButton = (
						<>
							{/* Back Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.back-button',
								}),
								SecondStepOnBackHandler,
								'back'
							)}
							{/* Next Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.next-button',
								}),
								SecondButtonOnNextHandler,
								'next',
								!selectedCarrier.code
							)}
						</>
					);

					// Callbacks for Third step
					const ThirdStepOnBackHandler = () => {
						setActiveStep(activeStep - 1);
						carrierConfig = null;
					};
					const ThirdButtonOnNextHandler = async () => {
						try {
							const updated = await updateCarrierConfig();
							if (updated) {
								setActiveStep(activeStep + 1);
							}
						} catch (err) {
							throw err;
						}
					};

					const ThirdButton = (
						<>
							{/* Back Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.back-button',
								}),
								ThirdStepOnBackHandler,
								'back'
							)}
							{/* Next Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.next-button',
								}),
								ThirdButtonOnNextHandler,
								'next'
							)}
						</>
					);

					// Callbacks for Fourth step
					const FourthStepOnBackHandler = () => {
						setActiveStep(activeStep - 1);
						tierOverrideConfig = null;
					};
					const FourthButtonOnSaveHandler = async () => {
						try {
							const updated = await updateTierOverrideConfig();
							if (updated) {
								saveCarrierDetails(
									selectedCarrier.code,
									selectedCarrier.description,
									carrierData,
									carrierConfig,
									tierOverrideConfig
								);
							}
						} catch (error) {
							throw error;
						}
					};

					const FourthButton = (
						<>
							{/* Back Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.back-button',
								}),
								FourthStepOnBackHandler,
								'back'
							)}
							{/* Save Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.save-button',
								}),
								FourthButtonOnSaveHandler,
								'next',
								showLoader,
								showLoader
							)}
						</>
					);

					buttons.push(FirstButton, SecondButton, ThirdButton, FourthButton);
				}

				break;
		}

		return buttons[activeStep];
	}, [selectedCarrier, steps, activeStep, showLoader, selectedSCAC]);

	/*
	 * This function returns the action buttons for each step based on the number of steps in the edit form.
	 * - e.g. For a 3-step form the first step will have a cancel and a next button,
	 * 	 the second step will have a back and a next button
	 *   and the third step will have a back and a save button
	 * - For edit-form the SCAC selection step is never there so the number of steps is 1 less that their equivalent create-form
	 */
	const manageEditDialogButtons = useCallback(() => {
		const buttons = [];

		switch (steps.length) {
			case 1:
				{
					/* For a 1-step form
						- The first step for edit is alwasy the description and the carrier selection (Although not changable) part
					 	- So it has a cancel and a next button
					*/

					// Callbacks for first step
					const FirstStepOnBackHandler = () => {
						setEditCarrierModal(false);
						carrierConfig = null;
						tierOverrideConfig = null;
						carrierData = null;
					};
					const FirstStepOnNextHandler = async () => {
						try {
							const updated = await updateCarrierDetails();
							if (updated) {
								saveCarrierDetails(userCarrier.carrierCode, userCarrier.carrierDescription, carrierData, null, null);
							}
						} catch (err) {
							props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
						}
					};

					const FirstButton = (
						<>
							{/* Cancel Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.cancel-button',
								}),
								FirstStepOnBackHandler,
								'back'
							)}
							{/* Save Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.save-button',
								}),
								FirstStepOnNextHandler,
								'next',
								showLoader,
								showLoader
							)}
						</>
					);

					buttons.push(FirstButton);
				}
				break;
			case 2:
				{
					/* For a 2-step form:
						- first step will have a cancel and a next button
						- the second step will have a back and a save button
					*/

					// Callbacks for first step
					const FirstStepOnBackHandler = () => {
						setEditCarrierModal(false);
						carrierConfig = null;
						tierOverrideConfig = null;
						carrierData = null;
					};
					const FirstStepOnNextHandler = async () => {
						// Next button action when carrier details filled
						try {
							const updated = await updateCarrierDetails();
							if (updated) {
								setActiveStep(activeStep + 1);
							}
						} catch (err) {
							props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
						}
					};

					const FirstButton = (
						<>
							{/* Cancel Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.cancel-button',
								}),
								FirstStepOnBackHandler,
								'back'
							)}
							{/* Next Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.next-button',
								}),
								FirstStepOnNextHandler,
								'next'
							)}
						</>
					);

					// Callbacks for second step
					const SecondStepOnBackHandler = () => {
						setActiveStep(activeStep - 1);
						if (selectedCarrier.code === CarriersEnum.FedExNative) {
							setIsTrackingRangeImported(true);
						}
					};

					const SecondStepOnSaveHandler = async () => {
						try {
							await updateCarrierConfig();
							if (!!carrierConfig) {
								saveCarrierDetails(
									userCarrier.carrierCode,
									userCarrier.carrierDescription,
									carrierData,
									carrierConfig,
									null
								);
							}
						} catch (err) {
							props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
						}
					};

					const SecondButton = (
						<>
							{/* Back Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.back-button',
								}),
								SecondStepOnBackHandler,
								'back'
							)}
							{/* Save Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.save-button',
								}),
								SecondStepOnSaveHandler,
								'next',
								showLoader,
								showLoader
							)}
						</>
					);

					buttons.push(FirstButton, SecondButton);
				}
				break;
			case 3:
				{
					/* For a 3-step form:
						- first step will have a cancel and a next button
						- the second step will have a back and a next button
						- the third step will back and a next button
					*/

					// Callbacks for first step
					const FirstStepOnBackHandler = () => {
						setEditCarrierModal(false);
						carrierConfig = null;
						tierOverrideConfig = null;
						carrierData = null;
					};
					const FirstStepOnNextHandler = async () => {
						// Next button action when carrier details filled
						try {
							const updated = await updateCarrierDetails();
							if (updated) {
								setActiveStep(activeStep + 1);
							}
						} catch (err) {
							props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
						}
					};

					const FirstButton = (
						<>
							{/* Cancel Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.cancel-button',
								}),
								FirstStepOnBackHandler,
								'back'
							)}
							{/* Next Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.next-button',
								}),
								FirstStepOnNextHandler,
								'next'
							)}
						</>
					);

					// Callbacks for second step
					const SecondStepOnBackHandler = () => {
						setActiveStep(activeStep - 1);
						setIsTrackingRangeImported(true);
					};

					const SecondButtonOnNextHandler = async () => {
						try {
							const updated = await updateCarrierConfig();
							if (updated) {
								setActiveStep(activeStep + 1);
							}
						} catch (err) {
							throw err;
						}
					};

					const SecondButton = (
						<>
							{/* Back Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.back-button',
								}),
								SecondStepOnBackHandler,
								'back'
							)}
							{/* Next Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.next-button',
								}),
								SecondButtonOnNextHandler,
								'next'
							)}
						</>
					);

					// Callbacks for third step
					const ThirdStepOnBackHandler = () => {
						setActiveStep(activeStep - 1);
					};
					const ThirdButtonOnNextHandler = async () => {
						try {
							const updated = await updateTierOverrideConfig();
							if (updated) {
								saveCarrierDetails(
									selectedCarrier.code,
									selectedCarrier.description,
									carrierData,
									carrierConfig,
									tierOverrideConfig
								);
							}
						} catch (err) {
							props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
						}
					};

					const ThirdButton = (
						<>
							{/* Back Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.back-button',
								}),
								ThirdStepOnBackHandler,
								'back'
							)}
							{/* Next Button */}
							{configStepperButton(
								props.intl.formatMessage({
									id: 'app.app-view.save-button',
								}),
								ThirdButtonOnNextHandler,
								'next',
								showLoader,
								showLoader
							)}
						</>
					);

					buttons.push(FirstButton, SecondButton, ThirdButton);
				}
				break;
		}

		return buttons[activeStep];
	}, [selectedCarrier, steps, activeStep, showLoader, selectedSCAC]);

	const renderNewCarrier = useCallback(
		(carrierForm: JSX.Element) => {
			return (
				<>
					<Grid
						container={true}
						direction='row'
						justifyContent='center'
						alignItems='center'
						className='height-100 pointer'
					>
						<Button
							startIcon={<Icon name='plus' />}
							fullWidth={true}
							variant='text'
							disabled={isAccountClosed}
							onClick={() => manageCarrierDialog(true)}
						>
							<strong>{intlService.GetFormattedMessage('app.app-view.add-carrier-account')}</strong>
						</Button>
					</Grid>
					{carrierForm}
				</>
			);
		},
		[isAccountClosed, manageCarrierDialog]
	);

	// Return card from here based on below conditions:
	// If true then return NEW CARD component
	// else CARD with CarrierAccount details

	if (props.isNew) {
		const carrierDialog = renderNewCarrierDialog();
		return renderNewCarrier(carrierDialog);
	}

	return (
		<Grid container={true}>
			<Grid item={true} xs={12} sm={12} md={12} lg={12} xl={12}>
				{renderEditCarrierDialog(userCarrier)}
				<Divider />
				<ListItem
					ContainerComponent='div'
					className={
						userCarrier.status !== CarrierAccountStatusEnum.Enabled &&
						userCarrier.status !== CarrierAccountStatusEnum.EnabledWithoutWatermark
							? 'pt-0 pb-0 opacity-60'
							: 'pt-0 pb-0'
					}
				>
					<ListItemAvatar>
						<div className='box'>
							<GridList cols={1} cellHeight={90} className='selected-carrier-list-tile'>
								<GridListTile classes={{ root: 'gridListTitle-root' }}>
									<div className='carriers-tile'>
										{userCarrier.visibility === CarrierStatusEnum.Private && <Ribbon text={userCarrier.visibility} />}
										<img key={userCarrier.id} src={userCarrier.logo} className='carrier-img carrier-card-img' />
									</div>
								</GridListTile>
							</GridList>
						</div>
					</ListItemAvatar>
					<ListItemText>
						<Grid container={true} direction='column'>
							<Grid item={true} xs={12} sm={12} md={12} lg={12} xl={12}>
								<Grid container={true}>
									<Grid item={true} xs={6} sm={4} md={4} lg={4} xl={4}>
										<Typography noWrap={true} color='inherit' variant='body2'>
											<strong>{`${intlService.GetFormattedMessage('app.carrier-account-id-label')}:`}</strong>
										</Typography>
									</Grid>
									<Grid item={true} xs={6} sm={8} md={8} lg={8} xl={8}>
										<Typography variant='body2' noWrap={true}>
											{userCarrier.id}
										</Typography>
									</Grid>
								</Grid>
							</Grid>
							<Grid item={true} xs={12} sm={12} md={12} lg={12} xl={12}>
								<Grid container={true}>
									<Grid item={true} xs={6} sm={4} md={4} lg={4} xl={4}>
										<Typography noWrap={true} color='inherit' variant='body2'>
											<strong>{`${intlService.GetFormattedMessage('app.carrier-account-name-label')}:`}</strong>
										</Typography>
									</Grid>
									<Grid item={true} xs={6} sm={8} md={8} lg={8} xl={8}>
										<Typography noWrap={true} variant='body2'>
											{userCarrier.name}
										</Typography>
									</Grid>
								</Grid>
							</Grid>
							<Grid item={true} xs={12} sm={12} md={12} lg={12} xl={12}>
								<Grid container={true}>
									<Grid item={true} xs={6} sm={4} md={4} lg={4} xl={4}>
										<Typography noWrap={true} color='inherit' variant='body2'>
											<strong>{`${intlService.GetFormattedMessage('app.carrier-code-label')}: `}</strong>
										</Typography>
									</Grid>
									<Grid item={true} xs={6} sm={8} md={8} lg={8} xl={8}>
										<Typography noWrap={true} variant='body2'>
											{userCarrier.carrierCode}
										</Typography>
									</Grid>
								</Grid>
							</Grid>
							<Grid item={true} xs={12} sm={12} md={12} lg={12} xl={12}>
								<Grid container={true}>
									<Grid item={true} xs={6} sm={4} md={4} lg={4} xl={4}>
										<Typography noWrap={true} color='inherit' variant='body2'>
											<strong>{`${intlService.GetFormattedMessage('app.carrier-account-status-label')}:`}</strong>
										</Typography>
									</Grid>
									<Grid item={true} xs={6} sm={8} md={8} lg={8} xl={8}>
										<Typography noWrap={true} variant='body2'>
											{intlService.GetFormattedMessage('app.carrier-account-' + userCarrier.status)}{' '}
											{accountService.IsAdmin(userData.user.role) &&
												userCarrier.carrierStatus === CarrierStatusEnum.Private &&
												`(${userCarrier.carrierStatus})`}
										</Typography>
									</Grid>
								</Grid>
							</Grid>
							{history.location.pathname === models.Module.CarrierAccounts.url && (
								<Grid item={true} xs={12} sm={12} md={12} lg={12} xl={12}>
									<Grid container={true}>
										<Grid item={true} xs={6} sm={4} md={4} lg={4} xl={4}>
											<Typography noWrap={true} color='inherit' variant='body2'>
												<strong>{`${intlService.GetFormattedMessage('app.carrier-card.app-name-label')}:`}</strong>
											</Typography>
										</Grid>
										<Grid item={true} xs={6} sm={8} md={8} lg={8} xl={8}>
											<Typography noWrap={true} variant='body2'>
												{accountService.getUserData().apps.find((e) => e.appId === props.carrier.appId)?.appName}
											</Typography>
										</Grid>
									</Grid>
								</Grid>
							)}
						</Grid>
					</ListItemText>
					<ListItemSecondaryAction>{!isAccountClosed && renderMenu()}</ListItemSecondaryAction>
				</ListItem>
				{/* Delete carrier component */}
				<CustomDialogBox
					open={openDeleteDialog}
					dialogTitle={props.intl.formatMessage({
						id: 'app.delete-carrier-label',
					})}
					maxWidth='md'
					dialogDescription={carrierDeleteDialogDescription}
					dialogYesButton={
						CustomDialogButtonTextConfigs.passCustomText ? CustomDialogButtonTextConfigs.YesButtonText : undefined
					}
					loading={showLoader}
					disabled={showLoader}
					closeCustomDialog={(dialogPanel: string, isCancel: boolean) => {
						if (isCancel) {
							setOpenDeleteDialog(false);
							setIsCarrierDeleteFailed(false);
							return;
						}

						// If deleting a carrier account operation fails
						// then call carrier account status update API on confirmation
						if (isCarrierDeleteFailed) {
							updateCarrierStatus(CarrierAccountStatusEnum.Disabled);
							setOpenDeleteDialog(false);
							return;
						}

						// else call delete operation
						deleteCarrier(userCarrier.appId, userCarrier.id);
					}}
				/>

				{/* Update carrrier account status carrier component */}
				<CustomDialogBox
					open={accountStatusDialog.openDialog}
					dialogTitle={props.intl.formatMessage({
						id: 'app.carrier.' + accountStatusDialog.accountStatus.toString().toLowerCase() + '-account-status',
					})}
					dialogDescription={props.intl.formatMessage({
						id: 'app.carrier.update-status-dialog-description',
					})}
					closeCustomDialog={(dialogPannel: string, isCancel: boolean) => {
						if (!isCancel) {
							updateCarrierStatus(accountStatusDialog.accountStatus);
						}
						setAccountStatusDialog((prevState) => ({
							openDialog: false,
							accountStatus: prevState.accountStatus,
						}));
					}}
				/>

				{/* Update carrier account payment type */}
				<CustomDialogBox
					open={configDialogContent.openConfig}
					fullWidth={true}
					maxWidth='md'
					dialogTitle={props.intl.formatMessage({
						id: 'app.carrier-card.configure-dialog-title',
					})}
					dialogDescription={null}
					closeCustomDialog={async (dialogPannel: string, isCancel: boolean) => {
						try {
							setConfigDialogContent((prevState) => ({
								...prevState,
								openConfig: false,
							}));
						} catch (error) {
							if (!Axios.isCancel(error)) {
								props.openSnackBar(sharedService.parseError(error.data), SnackBarVariants.Error);
							}
						}
					}}
					hideSubmitActionButton={true}
				>
					{/* Payment Mode Config Component */}
					{accountService.IsAdmin(userData.user.role) && (
						<PaymentModeConfigComponent
							userCarrier={userCarrier}
							configDialogContent={configDialogContent}
							setConfigDialogContent={setConfigDialogContent}
							setUserCarrierDetails={setUserCarrierDetails}
							openSnackBar={props.openSnackBar}
							defaultExpandAccordion={true}
						/>
					)}

					{/* AutoManifest Component */}
					{(userCarrier.carrierCode === CarriersEnum.USPSeVSNative ||
						userCarrier.carrierCode === CarriersEnum.USPSePostageNative) && (
						<USPSAutoManifestScheduleComponent
							sourceType={USPSAutoManifestScheduleSourceTypeEnum.CarrierAccount}
							sourceId={userCarrier.id}
							defaultExpandAccordion={userData.user.role === UserRole.AccountAdmin}
							openSnackBar={props.openSnackBar}
						/>
					)}
				</CustomDialogBox>
			</Grid>
		</Grid>
	);
};

export default injectIntl(withSnackBar(withStyles(styles)(CarrierCardComponent)));



// WEBPACK FOOTER //
// ./src/components/carriers/carrier-card.component.tsx